import _isBoolean from 'lodash/isBoolean';
import _isEmpty from 'lodash/isEmpty';
import _isNull from 'lodash/isNull';
import _isNumber from 'lodash/isNumber';
import _isUndefined from 'lodash/isUndefined';
export function isDefinedAndNotEmpty(value) {
  if (_isNumber(value)) {
    return true;
  }
  if (_isBoolean(value)) {
    return value;
  }
  return !_isUndefined(value) && !_isNull(value) && !_isEmpty(value);
}